// extracted by mini-css-extract-plugin
export default {"textarea":"textArea_textarea__ot5+V","double":"textArea_double__ZpgaB","triple":"textArea_triple__izBnQ","textareaWithLabel":"textArea_textareaWithLabel__mpefM"};